var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Composant-85-–-3","transform":"translate(-21.000000, -21.000000)","fill":"#FFFFFF","fillRule":"nonzero"},React.createElement("polygon",{"id":"Path","transform":"translate(40.000000, 40.156000) rotate(-90.000000) translate(-40.000000, -40.156000) ","points":"21 42.531 49.856 42.531 36.556 55.831 40 59.156 59 40.156 40 21.156 36.675 24.481 49.856 37.781 21 37.781"})))]);
}

ArrowUp.defaultProps = {"width":"38px","height":"39px","viewBox":"0 0 38 39","version":"1.1"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
